import { theme } from "../theme";

// ── Mini spark chart ───────────────────────────────────────────────────────────
export default function MiniChart({ history }) {
  if (!history || history.length < 2) return null;
  const w = 80, h = 32, pad = 3;
  const positions = history.map(h => h.our_position).filter(Boolean);
  if (positions.length < 2) return null;
  const min = Math.min(...positions), max = Math.max(...positions);
  const range = max - min || 1;
  const pts = positions.map((p, i) => {
    const x = pad + (i / (positions.length - 1)) * (w - pad * 2);
    const y = pad + ((p - min) / range) * (h - pad * 2);
    return `${x},${y}`;
  }).join(" ");
  const last = positions[positions.length - 1];
  const prev = positions[positions.length - 2];
  const color = last < prev ? theme.ok : last > prev ? theme.bad : theme.mut;
  return (
    <svg width={w} height={h}>
      <polyline points={pts} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.8" />
    </svg>
  );
}
